import { connect } from 'react-redux';
import { openModal } from '../../redux/modal';
import { receivePaymentResponse } from '../../actions/transaction';
import WorldpayIframe from './WorldpayIframe';
import Spinner from '../Spinner';

const mapDispatchToProps = (dispatch, props) => ({
  onResult: (result) => {
    dispatch(openModal({ content: <Spinner fadeIn />, label: 'loading' }));

    const data = {
      orderNumber: props.orderNumber,
      ...result.gateway,
    };

    switch (result.order.status) {
      case 'success':
        dispatch(receivePaymentResponse('worldpay', 'success', data));
        break;
      case 'error':
      case 'failure':
        dispatch(receivePaymentResponse('worldpay', 'failure', data));
        break;
      case 'cancelled_by_shopper':
        dispatch(receivePaymentResponse('worldpay', 'cancel', data));
        break;
      default:
        console.error('Unexpected result', result); // eslint-disable-line
        break;
    }
  },
});

export default connect(null, mapDispatchToProps)(WorldpayIframe);
